// Analytics event constants for AI Output Block tracking
export const ANALYTICS_EVENTS = {
	// AI Output Block Configuration Events
	AI_OUTPUT_BLOCK_ADDED: 'automation/ai_output_block/added',
	AI_OUTPUT_BLOCK_CONFIGURED: 'automation/ai_output_block/configured',
	AI_OUTPUT_BLOCK_REVIEW_TOGGLED: 'automation/ai_output_block/review_toggled',

	// AI Generation Execution Events (Frontend)
	AI_GENERATION_PREVIEW_STARTED: 'automation/ai_generation/preview_started',
	AI_GENERATION_PREVIEW_COMPLETED: 'automation/ai_generation/preview_completed',
	AI_GENERATION_PREVIEW_FAILED: 'automation/ai_generation/preview_failed',

	// Review States and Actions Events
	AI_OUTPUT_REVIEW_STARTED: 'automation/ai_output/review_started',
	AI_OUTPUT_APPROVE_ALL: 'automation/ai_output/approve_all',
	AI_OUTPUT_INDIVIDUAL_APPROVE: 'automation/ai_output/individual_approve',
	AI_OUTPUT_INDIVIDUAL_DISCARD: 'automation/ai_output/individual_discard',
	AI_OUTPUT_REVIEW_COMPLETED: 'automation/ai_output/review_completed',

	// Job Drawer Events
	AI_OUTPUT_JOB_DRAWER_OPENED: 'automation/ai_output/job_drawer_opened',
	AI_OUTPUT_MODAL_OPENED: 'automation/ai_output/modal_opened',
	AI_OUTPUT_MODAL_CLOSED: 'automation/ai_output/modal_closed',
} as const;
